import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import StationDiscountBase from './stationDiscountBase';
import StationDiscountGroupBase from './stationDiscountGroupBase';
import StationDiscountInterval from './stationDiscountInterval';
import StationDiscountActivity from './stationDiscountActivity';
export default {
  name: 'StationDiscount',
  components: {
    StationDiscountBase: StationDiscountBase,
    StationDiscountGroupBase: StationDiscountGroupBase,
    StationDiscountInterval: StationDiscountInterval,
    StationDiscountActivity: StationDiscountActivity
  },
  data: function data() {
    return {
      activeName: 'StationDiscountBase'
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('stationDiscount');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      this.activeName = tab.name;
    }
  }
};